import React from 'react'
import style from './MasProductos.module.css'

import imagen1 from '../../../../utils/images/box-7.png'
import imagen2 from '../../../../utils/images/box-8.png'
import CardProductos from '../../../generales/CardProductos'

const MasProductos = ({ t }) => {

  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.SmartSCC.More-products.title')}</p>
      <div className={style.productos}>
        <CardProductos
          imagen={imagen1}
          link={"/productos/smartsen"}
          title={"HomePage.Products.Smartsen"}
          text={"HomePage.Products.description-of-smartsen"}
        />
        <CardProductos
          imagen={imagen2}
          link={"/productos/smartIot"}
          title={"HomePage.Products.smartiot"}
          text={"HomePage.Products.description-of-smartiot"}
        />
      </div>
    </div>
  )
}

export default MasProductos
